<template>
  <div>
    <div class="form-group">
      <label class="control-label col-md-3 col-sm-3">
        {{ $t('LABEL_CUSTOM_SCORING_ACCEPTANCE_PARSING') }}
        <i
          v-tooltip.right="$t('LABEL_CUSTOM_SCORING_ACCEPTANCE_PARSING_TT')"
          class="fa fa-question-circle m-l-5"
        />
      </label>
      <div
        v-for="(step, index) in acceptanceParsing"
        :key="index"
        class="col-md-9"
        :class="{'col-sm-offset-3': index > 0}"
      >
        <div class="display-flex">
          <SearchableDropdown
            v-model="step.property"
            class="m-r-15 m-b-10 input--size-md"
            :config="selectablePropertiesConfig"
            :clearable="false"
            rules="required"
            required
            @change="updateAcceptanceParsingSettings"
          />
          <SearchableDropdown
            v-model="step.operator"
            class="m-r-15 m-b-10 input--size-sm"
            :config="acceptanceParsingComparisonConfig"
            :clearable="false"
            rules="required"
            required
            @change="updateAcceptanceParsingSettings"
          />
          <ValidationProvider
            v-slot="{ classes }"
            :ref="`acceptanceParsingValue${index}`"
            rules="required"
            slim
          >
            <div :class="classes">
              <input
                v-model="step.value"
                :name="`acceptanceParsingValue${index}`"
                type="text"
                class="form-control m-r-15 m-b-10 width-auto"
                @change="updateAcceptanceParsingSettings"
              />
              <label 
                v-t="'REQUIRED'"
                class="form-group__label-required"
              />
            </div>
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-md-3 col-sm-3">
        {{ $t('LABEL_CUSTOM_SCORING_SCORE_PARSING') }}
        <i
          v-tooltip.right="$t('LABEL_CUSTOM_SCORING_SCORE_PARSING_TT')"
          class="fa fa-question-circle m-l-5"
        />
      </label>
      <div class="col-md-9">
        <div class="display-flex">
          <SearchableDropdown
            v-model="scoreParsing"
            class="m-r-15 m-b-10 input--size-md"
            :config="selectablePropertiesConfig"
            :clearable="false"
            @change="updateScoreParsingSettings"
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-md-3 col-sm-3">
        {{ $t('LABEL_CUSTOM_SCORING_CUSTOM_TAGS') }}
        <i
          v-tooltip.right="$t('LABEL_CUSTOM_SCORING_CUSTOM_TAGS_TT')"
          class="fa fa-question-circle m-l-5"
        />
      </label>
      <div class="col-md-9">
        <div class="display-flex m-b-15">
          <SearchableDropdown
            v-model="selectedTag"
            class="m-r-15 input--size-md"
            :config="customTagsConfig"
            :clearable="false"
          />
          <button
            type="button"
            class="btn btn-success btn-sm"
            :disabled="!selectedTag"
            @click="addCustomTag(selectedTag)"
          >
            {{ $t('ADD') }}
          </button>
        </div>
        <div 
          v-if="customTagsSelected && customTagsSelected.length" 
          class="display-flex flex--direction-row flex--wrap flex--align-start flex--justify-start p-r-20"
        >
          <span
            v-for="(tag, index) in customTagsSelected"
            :key="index"
            class="label label-primary label--basic m-r-10 m-b-10"
          >
            {{ tag.label }}
            <i
              class="fa fa-close clickable m-l-5"
              aria-hidden="true"
              @click="removeCustomTag(tag, index)"
            />
          </span>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
import { cloneDeep } from 'lodash';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { acceptanceParsingComparisonConfig } from '../../helpers/constants';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';

export default {
  name: 'CustomScoringParsingSettings',
  components: {
    SearchableDropdown
  }, 
  props: {
    acceptanceParsing: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedScoreParsing: {
      type: Object,
      default() {
        return null;
      },
    },
    customTagsSelected: {
      type: Array,
      default() {
        return [];
      },
    },
    selectablePropertiesConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    customTagsConfig: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      selectedTag: '',
      scoreParsing: cloneDeep(this.selectedScoreParsing)
    };
  },
  watch: {
    'selectedScoreParsing': {
      immediate: false,
      async handler(newValue) {
        this.scoreParsing = cloneDeep(newValue)
      }
    },
  },
  created() {
    this.acceptanceParsingComparisonConfig = acceptanceParsingComparisonConfig;
  },
  methods: {
    updateAcceptanceParsingSettings() {
      this.$emit('updateAcceptanceParsingSettings');
    },
    updateScoreParsingSettings(scoreParsing) {
      this.$emit('updateScoreParsingSettings', scoreParsing);
    },
    addCustomTag(tag) {
      this.$emit('addCustomTag', tag);
      this.selectedTag = '';
    },
    removeCustomTag(tag, index) {
      this.$emit('removeCustomTag', { tag, index });
    },
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  } 
};
</script>